/**
 * @generated SignedSource<<7b6593a0cecad6c7f2ac048655b795b2>>
 * @relayHash 6f497ee42cceeed90493221a5d1cd71f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 80e62655ce84f6844f14e6025079b37ef30233d16282063fafc09efada16c613

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "80e62655ce84f6844f14e6025079b37ef30233d16282063fafc09efada16c613",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
